import type { SVGProps } from "react";

export function IconBlackFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.9999 5.75C54.7572 5.75 53.7499 6.75736 53.7499 8C53.7499 9.24264 54.7572 10.25 55.9999 10.25C57.2425 10.25 58.2499 9.24264 58.2499 8C58.2499 6.75736 57.2425 5.75 55.9999 5.75ZM52.2499 8C52.2499 5.92893 53.9288 4.25 55.9999 4.25C58.0709 4.25 59.7499 5.92893 59.7499 8C59.7499 10.0711 58.0709 11.75 55.9999 11.75C55.8156 11.75 55.6344 11.7367 55.4572 11.711L46.5905 36.2648L38.1348 58.6667H36.5315L43.2942 40.75H2.62549L22.8051 26.5889L6.07183 11.25H54.0289L54.0463 11.2016C52.9689 10.5428 52.2499 9.35535 52.2499 8Z"
        fill="#23232C"
      />
    </svg>
  );
}
